import React from 'react'
import { RiDeleteBin7Line } from 'react-icons/ri'

 const DeleteBtn = ({ size }) => {
    return (
        <RiDeleteBin7Line className="green-btn-plus" size={size} />
    )
}

export default DeleteBtn